import type { IChatMessage } from '@/apiClient/types/chat'

/** Prefer `message_id` from `message_complete`, else last assistant row. */
export function findAssistantMessageForMermaidMetrics(
  messages: IChatMessage[],
  messageId?: string,
): IChatMessage | undefined {
  if (messageId) {
    const match = messages.find(
      (message) => message.id === messageId && message.role === 'assistant',
    )
    if (match) return match
  }

  return messages.findLast((message) => message.role === 'assistant')
}
